export default __webpack_public_path__ + "static/media/mantenimiento_icon.adcc410b.svg";